import colorVariants from "@/json/color_variants.json"

const PillButton = ({key, data, colors, selectedId, callback }) => {

     const backgroundColorVariants = {
          gray: 'bg-gray-100 dark:bg-gray-600',
          white: 'bg-white dark:bg-gray-900',
          blue: 'bg-blue-600',
          indigo: 'bg-indigo-600 ',
          violet: 'bg-violet-600',
          purple: 'bg-purple-600 ',
          fuchsia: 'bg-fuchsia-600 ',
          pink: 'bg-pink-600 ',
      
        }

  const borderColorVariants = {
    amber: "border-amber-500",
    green: "border-green-500",
    gray: "border-gray-500 dark:border-gray-500",
    white: "bg-white dark:bg-gray-900",
    blue: "border-blue-600 dark:border-blue-400",
    indigo: "border-indigo-600 dark:border-indigo-400",
    violet: "border-violet-600 dark:border-violet-400",
    purple: "border-purple-600 dark:border-purple-400",
    fuchsia: "border-fuchsia-600 dark:border-fuchsia-400",
    pink: "border-pink-600 dark:border-pink-400",
  };

  const textColorVariants = {
    gray: "text-gray-500 dark:text-gray-500",
    white: "text-white",
    blue: "text-blue-600 dark:text-blue-400",
    indigo: "text-indigo-600 dark:text-indigo-400",
    violet: "text-violet-600 dark:text-violet-400",
    purple: "text-purple-600 dark:text-purple-400",
    fuchsia: "text-fuchsia-600 dark:text-fuchsia-400",
    pink: "text-pink-600 dark:text-pink-400",
  };
  return (
//     <div
//       className={`w-full mx-auto text-center mt-auto text-lg py-1 border-2 rounded-3xl max-w-64 ${backgroundColorVariants[colors.background]} border-2 ${borderColorVariants[colors.border]}`}
//     >
     <span key={key} className={`${selectedId === data.id ? `${backgroundColorVariants[colors.border]} text-white dark:bg-gray-900 ` : 'bg-white dark:bg-gray-700'} ${selectedId !== data.id && `hover:border-white dark:hover:border-gray-300`}  duration-300 ease-in-out cursor-pointer w-full mx-auto text-center mt-auto text-base py-2 px-4 border-2 rounded-3xl max-w-96 ${backgroundColorVariants[colors.background]} border-2 ${borderColorVariants[colors.border]} ${textColorVariants[colors.text]}`} onClick={()=>{callback({selectedCategoryId: data.id, selectedCategoryColors: colors.border, selectedCategoryName: data.caption})}}>{data.caption}</span>

//     </div>
  );
};

export default PillButton;
